export default {
    namespaced: true,
    state: {
        filters: {
            sort: 'created',
            asset: [],
            build: [],
            distance: 500,
            dob: [18, 100],
            ethnicity: [],
            extra: [],
            location: '',
            latitude: '',
            longitude: '',
            orientation: [],
            region: '',
            smoke: '',
            type: [],
            // extended fields
            attitude: [],
            behaviour: [],
            characterType: [],
            childrenHave: [],
            childrenLike: [],
            drink: [],
            employment: [],
            hair: [],
            hairColour: [],
            height: [48, 96],
            materialistic: [],
            personality: [],
            relationship: [],
            religion: [],
            socialClass: [],
            transport: [],
            page: 1
        },
        resetValues: {}
    },
    mutations: {
        CAPTURE_FILTERS(state) {
            state.resetValues = Object.assign({}, state.filters, { type: [] });
        },
        RESET_FILTERS(state, presetFilters) {
            // reset ALL filters. (optional) pass in presetFilters to update new values
            state.filters = Object.assign({}, state.resetValues, { type: [] }, presetFilters);
        },
        SET_FILTER(state, data) {
            // data = { key: filter, value: value } || [{ },{ }...]
            let changePage = false;
            if (!Array.isArray(data)) {
                const { key } = data;
                const { value } = data;
                changePage = key === 'page';

                if (key === 'type') {
                    if (state.filters.type.length < 2 && value !== state.filters.type[0]) {
                        // if none active or only otherType is active
                        state.filters.type.push(value);
                        state.filters.type.sort();
                    } else {
                        // if both active or selected is already active -> switch to otherType
                        state.filters.type = [value === 1 ? 2 : 1];
                    }
                } else {
                    state.filters[key] = value;
                }
            } else {
                data.forEach((filter) => {
                    changePage = filter.key === 'page';
                    state.filters[filter.key] = filter.value;
                });
            }

            if (!changePage) {
                state.filters.page = 1;
            }
        }
    }
};
